import { render, staticRenderFns } from "./updatePsw.vue?vue&type=template&id=68ffac0d&scoped=true&"
import script from "./updatePsw.vue?vue&type=script&lang=js&"
export * from "./updatePsw.vue?vue&type=script&lang=js&"
import style0 from "./updatePsw.vue?vue&type=style&index=0&id=68ffac0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ffac0d",
  null
  
)

export default component.exports